module.exports = __webpack_public_path__ + "img/krabi_eng.fbe8d589.png";